<template>
  <div class="agreement">
    <!--顶部导航-->
    <Navbar title="协议内容" />
    <div class="content" v-if="protocolContent.length == 1">
       <div class="protocol-content">
            <div class="title">
              {{ item.configName }}
            </div>
            <div class="content" v-html="item.configValue"></div>
          </div>
    </div>
    <div v-else>
      <van-tabs
        v-model="active"
        scrollspy
        sticky
        offset-top="56px"
        :line-width="0"
        :line-height="0"
      >
        <van-tab v-for="(item, index) in protocolContent" :key="index">
          <template #title>
            <div class="tab-title" :class="{ active: active === index }">
              {{ item.configName }}
            </div>
          </template>
          <div class="protocol-content">
            <div class="title">
              {{ item.configName }}
            </div>
            <div class="content" v-html="item.configValue"></div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import { getAgreementList } from "@/api/index.js";

export default {
  name: "agreement",
  components: {
    Navbar,
  },
  data() {
    return {
      protocolContent: [],
      active: 0,
    };
  },
  async mounted() {
    getAgreementList({ pageNumber: 1,pageSize: 100 }).then((res) => {
      if (res.code === 2000) {
        this.protocolContent = res.data.recordList;
      } else {
        this.$toast(res.msg || res.message || "请求失败");
      }
    });
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
.agreement {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #fff;
  word-break: break-all; 
  overflow-wrap: break-word;
}
.tab-title {
  padding: 3px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-family: "Regular";
  color: rgba(51, 51, 51, 0.4);
  background: #ebebeb;
}
.active {
  background: #1d70f7;
  color: #fff;
}
.protocol-content {
  padding: 16px;
}
.title {
  color: #000000;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  padding: 40px 0px;
}
.content {
  font-size: 12px;
}
.content-sentinel {
  height: 120px;
  width: 100%;
}
/* Vue 3 推荐写法 */
::v-deep(.van-tabs__line) {
  /* 初始时通过 transition 延迟显示，或者给个透明度，避开刚进页面的闪烁 */
  animation: fadeInLine 0.5s ease-in-out forwards;
  background: none !important;
}

@keyframes fadeInLine {
  0% {
    opacity: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
